
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/error",
      function () {
        return require("private-next-pages/auth/error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/error"])
      });
    }
  